import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { PackagesService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { PackagesActivities } from '../../models'

const log = new Logger('PackagesActivitiesDetailResolver')
@Injectable({ providedIn: 'root' })
export class PackagesActivitiesDetailResolver
  implements Resolve<Observable<PackagesActivities>> {
  constructor(
    private packageServices: PackagesService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['pid']
    
    return this.packageServices.getPackagesActivitiesDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/packages']))
    )
  }
}
